import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./errors";

const RETRYABLE_STATUSES = new Set([0, 408, 429, 500, 502, 503, 504]);
const MAX_ATTEMPTS = 3;
const BACKOFF_CAP_MS = 8_000;

const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (failureCount >= MAX_ATTEMPTS) return false;
  if (error instanceof ApiError) return RETRYABLE_STATUSES.has(error.status);
  return false;
};

const retryDelay = (attemptIndex: number): number =>
  Math.min(1_000 * 2 ** attemptIndex, BACKOFF_CAP_MS);

export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 300_000,
        refetchOnWindowFocus: false,
        retry: shouldRetry,
        retryDelay,
      },
      mutations: { retry: false },
    },
  });
